<div class="bg-white rounded-lg min-h-[400px] flex justify-between flex-col shadow-greyLightBox">
  <div class="pt-6 pb-8 md:py-7">
    <ng-content select="*"></ng-content>
  </div>
  <!-- <div class="pb-4  w-full">
    <div class="py-4 border-t border-[#F1F3F9]">
      <ng-content select="[buttons]"></ng-content>
    </div>
  </div> -->
</div>
